import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  DOCUMENT,
  ChangeDetectionStrategy
} from "@angular/core";
import { distinctUntilChanged, filter, map, Subject, switchMap, takeUntil, tap } from "rxjs";
import { PollSetupService } from "../polls-setup.service";
import { PollTemplate, QuestionForPreview } from "../create-poll/create-poll.type";
import { TemplateBank } from "./poll-templates.type";
import { UserTeam } from "@teammood/shared/util/user";
import { ActivatedRoute } from "@angular/router";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";


@Component({
    selector: "poll-templates",
    templateUrl: "./poll-templates.component.html",
    styleUrls: ["./poll-templates.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollTemplatesComponent implements OnInit, OnChanges, OnDestroy {
    

    private _destroy$ = new Subject<void>();
    templateBank: TemplateBank;
    filteredTemplateBank: TemplateBank = new TemplateBank([]);
    templateForPreview: QuestionForPreview;

    @Input() searchTerm: string;
    @Input() teams: UserTeam[];

    @Output() onSelectTemplate: EventEmitter<PollTemplate> = new EventEmitter();
    @Output() onPostNowPoll: EventEmitter<PollTemplate> = new EventEmitter();

    protected selectedTemplate: PollTemplate;

    constructor(
        private pollSetupService: PollSetupService,
        private route: ActivatedRoute,
        private breakpointObserver: BreakpointObserver,
        @Inject(DOCUMENT) private document: Document
    ){}

    async ngOnInit(){
        this.pollSetupService.getTemplateBank()
            .pipe(
                tap(bank => {
                    this.templateBank = bank;
                    this.filteredTemplateBank = bank;
                }),
                switchMap(bank => {
                   return this.route.queryParams.pipe( // scroll to item
                       filter(params => !!params['focus']),
                       tap(params => {
                           const focusId = params['focus'];
                           const selectedTemplate = bank.templateListByTopics.flatMap(topic => topic.templates).find(template => template.id === focusId);

                           if (selectedTemplate) {
                               this.setTemplateForPreview(selectedTemplate);

                               setTimeout(() => {
                                   this.document.getElementById(focusId).scrollIntoView({ behavior: "smooth", block: "start" })
                               }, 1000);
                           }
                       })
                   );
                }),
                takeUntil(this._destroy$)
            )
            .subscribe()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.searchTerm && changes.searchTerm.previousValue){
            this.apply_search()
        }
        if(changes.selectedTemplate?.currentValue === undefined){
            this.templateForPreview = undefined
        }
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    apply_search() {
        if(this.searchTerm === '') {
            this.filteredTemplateBank = this.templateBank;
        }else{
            this.filteredTemplateBank = this.templateBank.search(this.searchTerm);
        }
    }

    setTemplateForPreview(template: PollTemplate){
        this.templateForPreview = {
            label: template.label,
            choices: template.answerOptions.choices
        }
        this.selectedTemplate = template;
        
        if(this.breakpointObserver.isMatched('(max-width: 767px)')){ // no preview for small screens
            this.selectTemplate(template)
        }
    }

    selectTemplate(template: PollTemplate){
        this.onSelectTemplate.emit(template);
    }

    postNow(template: PollTemplate){
        this.onPostNowPoll.emit(template);
    }

}